import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './metaCombustivelModeloForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';

import { 
	getListaConsulta as getLista, getListaRota
} from './metaCombustivelModeloActions';
import {
	verificarTermoUso, confirmarTermoUso
} from '../metaCombustivelTermoUso/metaCombustivelTermoUsoActions';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import consts from '../consts';
import ContentCardFooter from '../common/template/contentCardFooter';

class MetaCombustivelModeloConsulta extends Component {

	state = {
		linhaSelecionada: null,
		ordenacao: {
			datahora_metaCombustivelModelo: 1
		}
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaRota();
		this.props.verificarTermoUso();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />
					
					{!this.props.statusTermoUso ? (
						<div />
					) : (this.props.statusTermoUso.aceito ? (
						this.lista()
					) : (
						this.termoUso()
					))}
                </Content>
            </div>
        )
    }

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	lista() {

		let lista = this.props.lista.filter(item => {

			return true;			
		});

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Placa'
							value={this.state.placa}
							onChange={value => {
								this.setState({ ...this.state, placa: value });
								this.props.getLista(value || '');
								this.props.verificarTermoUso();
							}} />
					</Row>

					<div 
						style={{ 
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 190}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 190}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 190}px`
										: `${window.innerHeight - 190}px`
									)
								)
							)
						}}>
						<Table responsive border striped alturaFixa 
							maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 190}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 190}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 190}px`
										: `${window.innerHeight - 190}px`
									)
								)
							)}>
							<THead>
								<Tr backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}>
									<Th maxWidth={200} width={200} paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Peso</Th>
									{this.props.listaRota.map(rota => (	
										<Th key={rota.id} maxWidth={200} width={200} paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>{rota.nome}</Th>
									))}
								</Tr>
							</THead>
							{this.props.lista.map(placa => {
								
								const listaPeso = this.props.listaPeso.filter(peso => {
									return placa.listaMedia.filter(itemMeta => 
										itemMeta.peso_inicial == peso.peso_inicial
										&& itemMeta.peso_final == peso.peso_final
									).length;
								});

								return (
									<TBody key={placa.placa}>
										<Tr>
											<Td colspan={this.props.listaRota.length + 1} bold color={'#fff'} alignCenter>
												{placa.placa} - {placa.nome_marca} - {placa.nome_modelo}
											</Td>
										</Tr>

										{!listaPeso.length &&
										<Tr>
											<Td colspan={this.props.listaRota.length + 1} bold backgroundColor={'#ffffff'} color={'#000'} alignCenter>
												Nenhuma média definida
											</Td>
										</Tr>}

										{listaPeso.map((peso, i) => (
											<Tr key={peso.id}
												backgroundColor={this.state.linhaSelecionada == peso.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')} >
												<Td maxWidth={200} width={200} bold color={'#000'} alignCenter
													onClick={() => this.setState({ ...this.state, linhaSelecionada: peso.id })}>{peso.peso_inicial} - {peso.peso_final}</Td>
												{this.props.listaRota.map(rota => {

													const meta = placa.listaMedia.filter(itemMeta => 
														itemMeta.id_meta_combustivel_rota == rota.id
														&& itemMeta.peso_inicial == peso.peso_inicial
														&& itemMeta.peso_final == peso.peso_final
													)[0];
													
													return (
														<Td maxWidth={200} width={200} key={rota.id} color={'#000'} alignCenter >
															{FormatUtils.formatarValorTela(meta ? meta.media : 0, 2)}
														</Td>
													);
												})}
											</Tr>
										))}
									</TBody>
								);
							})}
						</Table>
					</div>
				</ContentCardBody>
			</ContentCard>
		);
	}

	termoUso() {
		return (
			<>
				{(this.props.statusTermoUso && this.props.statusTermoUso.termoUso) &&
				<ContentCard>
					<ContentCardHeader>
						<Row alignCenter>
							<Grid cols='12 12 12 12'>
								<label style={{ width: '100%', fontSize: 16, marginTop: 12, textAlign: 'center' }}>Para continuar, você precisa ler os termos e clicar em "Confirmo que li e concordo com os termos de uso"</label>
							</Grid>
						</Row>
					</ContentCardHeader>
					
					<iframe
						src={`${consts.URL}/${this.props.statusTermoUso.termoUso.arquivo}`}
						width='100%'
						height={window.innerHeight - 200}
						style={{ border: 'none' }} >
					</iframe>
					
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='12 12 6 4'>
								<button 
									type='button' 
									class='btn btn-block btn-lg btn-primary'
									onClick={() => {
										this.props.confirmarTermoUso(this.props.statusTermoUso.termoUso.id);
									}}>
									Confirmo que li e concordo com os termos de uso
								</button>
							</Grid>
						</Row>
					</ContentCardFooter>
				</ContentCard>}
			</>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.metaCombustivelModelo.aguardando,
	modoTela: state.metaCombustivelModelo.modoTela,
	lista: state.metaCombustivelModelo.listaConsulta,
	listaRota: state.metaCombustivelModelo.listaRota,
	listaPeso: state.metaCombustivelModelo.listaPeso,
	statusTermoUso: state.metaCombustivelTermoUso.statusTermoUso
});
const mapDispatchToProps = dispatch => bindActionCreators({
	getLista, getListaRota,
	verificarTermoUso, confirmarTermoUso
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MetaCombustivelModeloConsulta);
